import React from "react";
// import LeaderboardEntryPoint from "./leaderboardEntryPoint";
import Big7DrawsEntryPoint from "./big7DrawsEntryPoint";

const FeelingLuckySection = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="text-gray-1 font-jost text-xs font-medium leading-4 lg:text-sm lg:leading-5 uppercase">
        FEELING LUCKY?
      </div>
      <div className="flex flex-col gap-4">
        {/* <LeaderboardEntryPoint /> */}
        <Big7DrawsEntryPoint />
      </div>
    </div>
  );
};

export default FeelingLuckySection;
